import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {HeartbeatService} from '../service';
import * as HeartbeatActions from './heartbeat.actions';
import * as UserStoreActions from '../../user-access/user-stores-store/user-store.actions';
import {heartBeatApplicationOnUserActivity} from './heartbeat.actions';
import {map, tap} from 'rxjs/operators';

@Injectable()
export class HeartbeatEffects {

  //#region START HEARTBEAT
  /**
   * ### startHeartbeat$
   * Effect to handle starting the heartbeat service.
   *
   * This effect listens for the `startHeartbeat` action,
   * triggers the `heartbeatService.start()` method,
   * and does not dispatch any further actions.
   *
   * ### Trigger
   * - `HeartbeatActions.startHeartbeat`
   *
   * ### Flow
   * 1. Triggered by the `startHeartbeat` action.
   * 2. Calls `heartbeatService.start()` to begin heartbeat monitoring.
   * 3. Does not dispatch any success or failure actions.
   *
   * ### Side Effects
   * - Starts internal timers and listeners in the heartbeat service.
   *
   * ### Returns
   * - None (dispatch: false)
   */
  startHeartbeat$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(HeartbeatActions.startHeartbeat),
        tap(() => {
          this.heartbeatService.start();
        }),
      ),
    {dispatch: false},
  );

  //#endregion

  //#region BEAT HEARTBEAT ON USER ACTIVITY
  /**
   * ### heartBeatApplicationOnUserActivity$
   * Effect to update the user's last seen timestamp on heartbeat activity.
   *
   * This effect listens for the `heartBeatApplicationOnUserActivity` action
   * and dispatches the `updateLastSeen` action accordingly.
   *
   * ### Trigger
   * - `heartBeatApplicationOnUserActivity`
   *
   * ### Flow
   * 1. Triggered by the `heartBeatApplicationOnUserActivity` action.
   * 2. Dispatches `UserStoreActions.updateLastSeen` to update user activity timestamp in the store.
   *
   * ### Side Effects
   * - Updates the user's last seen time in the user store state.
   *
   * ### Returns
   * - On success: `UserStoreActions.updateLastSeen`
   */
  heartBeatApplicationOnUserActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(heartBeatApplicationOnUserActivity),
      map(() => UserStoreActions.updateLastSeen()),
    ),
  );

  //#endregion

  constructor(
    private actions$: Actions,
    private heartbeatService: HeartbeatService,
    private readonly store: Store,
  ) {
  }

}
